module.exports = __webpack_public_path__ + "img/bpfxcbsf.14afe872.png";